<script>
  export default {
    name: 'OutlinedInput',

    props: {
      label: {
        type: String,
      },
      hideRequiredStar: {
        type: Boolean,
        default: false,
      },
      hideLabel: {
        type: Boolean,
        default: false,
      },
      dataTestId: {
        type: String,
      },
    },
  };
</script>

<template>
  <label>
    <span v-if="!hideLabel" class="white--text label" :class="{ required: !hideRequiredStar }">{{ label }}</span>
    <v-text-field
      v-bind="$attrs"
      label=""
      outlined
      class="mt-1 outlined-input"
      ref="input"
      :data-test-id="dataTestId"
      @input="$emit('input', $event)"
      @blur="$emit('blur', $event)"
      @paste="$emit('paste', $event)"
    >
      <template #append>
        <slot name="append"></slot>
      </template>
      <template #append-outer>
        <slot name="append-outer"></slot>
      </template>
      <template #prepend>
        <slot name="prepend"></slot>
      </template>
      <template #prepend-inner>
        <slot name="prepend-inner"></slot>
      </template>
      <template #message="props">
        <slot name="message" v-bind="props"></slot>
      </template>
    </v-text-field>
  </label>
</template>

<style scoped lang="scss">
  @import '@/scss/mixins.scss';
  @include outlined-input;
</style>
